import type { FetchResponseI } from 'types';

/**
 * Stable error code returned by the backend when a mutation is attempted on a
 * session whose `isManuallyCompleted` is `true`. The escape is to call
 * `POST /sessions/:id/uncomplete` first.
 */
export const SESSION_COMPLETED_IMMUTABLE_CODE = 'session_completed_immutable';

export const isImmutableSessionError = <T>(response: FetchResponseI<T> | null | undefined): boolean =>
  response?.code === SESSION_COMPLETED_IMMUTABLE_CODE;
